import React from "react";
import Markdown from "react-remarkable";
import Piwik from "./Piwik";

class DocumentationApi extends React.Component {

    componentDidMount() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    render() {
        let content = `
# Api

## Index
* [Call](#call)
* [Types](#types)
* [Miscellaneous](#miscellaneous)

## Event
WID provides API, to push event into the application.

### Authentification
WID uses an API key. The key is generated by the user in configuration > application.
That key is the identifier of your user in WID.

### <a class="anchor" name="call">Call</a>

You need to call this url to pass events:

     http://<server name>/webhook/<api key>

In you have to pass as body parameters an JSON with:

    [{
        beginDateTime: <number in milisecond>,
        endDateTime: <number in milisecond>,
        type: <string>,
        source: <string>,
        data: <object>
    }, {}, ...]

Example:

    [{
        beginDateTime: 1469449507985,
        endDateTime: 1469449507985,
        type: "note",
        source: "me",
        data: {
            content: "This is a note !"
        }
    }]

### <a class="anchor" name="types">Types</a>

You can create your own type. WID provides some basic type.

#### scm

Source control manager.

Data example:

    {
        project: wid,
        namespace: chorem
        type: "commit",
        id : 8484848
        message: "commit message"
        author: test@
        url: "http://"
        added: ["test.js"],
        modified: [],
        removed: []
    }

#### code

Metric on code.

Data example:

    {
        host: "me",
        userAgent: "wakatime OS ..."
        project: "wid",
        language: "javascript",
        branch: "master",
        entity: "api.js",
        type: "file",
        lines: 252,
        plugin: "atom"
    }

#### idle

Detect idle.

Data example:

    {
        device: "me"
    }

#### application

Application used.

Data example:

    {
        device: "me",
        command: "firefox",
        name: "Firefox"
        title: "Wid"
    }

#### note

Text enter by the user.

Data example:

    {
        content: "This is a note !"
    }

#### shell

Command shell.

Data example:

    {
        device: "server",
        command: "firefox --harmony",
        program: "firefox",
        path: "/home/test",
        shell: "bash",
        duration: 18
    }

#### task

Task.

Data example:

    {
        device: "me",
        description: "my task",
        status: "completed",
        uid: "azertyuiop"
    }

#### call

Phone call.

Data example:

    {
        device: "me",
        type: "outgoing", // or missed or incomming
        number: "23456789",
        name: "Dupond test"
    }

#### calendar

Calendar information.

Data example:

    {
        device: "me",
        title: "RDV",
        description: "Meeting"
    }

#### step

Number of step do.

Data example:

    {
        device: "me",
        number: 45
    }

#### heartbeat

Heartbeat.

Data example:

    {
        device: "me",
        pulse : 160 // per min
    }

#### location

Where you are.

Data example:

    {
        device: "me",
        time: 23456789,
        provider: "gps", // or network or wifi
        speed: 12,
        latitude: 0.34567,
        longitude: 0.23456789,
        altitude: 3,
        accuracy: 30
    }

#### mark

Create an mark if the begin date is different of end date, an activity is created with the tags contains in data.

Data example:

    {
        device: "me"
        tags: ["wid", "api", "documentation"],
        action: "start"
    }

### <a class="anchor" name="miscellaneous">Miscellaneous</a>

You need a wrapper to the WID API only if you cannot control the call as gitlab hooks.
In this case you have to create a wrapper to generate the call. You can propose your code in oder to
integrate in WID application server.
`;

        return (
            <div className="documentation">
                <Piwik />
                <Markdown options={{html: true}} source={content} />
            </div>
        );
    }
}

export default DocumentationApi;



/** WEBPACK FOOTER **
 ** ./src/js/components/DocumentationApi.js
 **/